var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11454_9164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 23.4267C29 21.4667 28.2486 19.6267 26.8777 18.24L24.1491 15.48C23.0286 14.3467 22.4091 12.84 22.4091 11.24V8C22.4091 3.58667 18.8632 0 14.5 0C10.1368 0 6.59091 3.58667 6.59091 8V11.24C6.59091 12.84 5.97136 14.3467 4.85091 15.48L2.12227 18.24C0.751364 19.6267 0 21.4667 0 23.4267V26.6667H9.88636V27.3333C9.88636 29.9067 11.9559 32 14.5 32C17.0441 32 19.1136 29.9067 19.1136 27.3333V26.6667H29V23.4267ZM17.7955 27.3333C17.7955 29.1733 16.3191 30.6667 14.5 30.6667C12.6809 30.6667 11.2045 29.1733 11.2045 27.3333V26.6667H17.7955V27.3333ZM27.6818 25.3333H1.31818V23.4267C1.31818 21.8267 1.93773 20.32 3.05818 19.1867L5.78682 16.4267C7.15773 15.04 7.90909 13.2 7.90909 11.24V8C7.90909 4.32667 10.8684 1.33333 14.5 1.33333C18.1316 1.33333 21.0909 4.32667 21.0909 8V11.24C21.0909 13.2 21.8423 15.04 23.2132 16.4267L25.9418 19.1867C27.0623 20.32 27.6818 21.8267 27.6818 23.4267V25.3333Z",
    fill: "#91231F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11454_9164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.196ea4b85a531aaa9f0b7da8630e0692.svg";
export { ForwardRef as ReactComponent };